import apiClient from './client';

export const autoRewardRulesKidApi = {
  list: () => apiClient.get('/auto_reward_rules')
};

export default autoRewardRulesKidApi;
